module.exports = __webpack_public_path__ + "static/media/S3N10-2.e09eeaf0.svg";